import { useIntl } from "react-intl";

import { Editions, ProductKeys } from "@atlassiansox/asc-stargate";

import { useCrossFlowFrontendTouchpoint } from "@/components/cross-flow/touchpoint";
import ContentBlock from "@/components/wpl/content-block/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

const HeroSection = () => {
    const intl = useIntl();
    const getItFreeText = intl.formatMessage({
        id: "JiraProductDiscoveryPage.hero.ctaLabel",
        defaultMessage: "Get it free"
    });
    const signupLink = useLocalizedHref(
        "/try/cloud/signup?bundle=jira-product-discovery"
    );
    const { openCrossFlow } = useCrossFlowFrontendTouchpoint({
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        edition: Editions.FREE,
        redirectUrl: signupLink
    });
    return (
        <Row layout="8">
            <ContentBlock
                headerText={intl.formatMessage({
                    id: "JiraProductDiscoveryPage.hero.heading",
                    defaultMessage: "From ideas to impact, build what matters"
                })}
                headerType="h1"
                bodyText={intl.formatMessage({
                    id: "JiraProductDiscoveryPage.hero.body",
                    defaultMessage:
                        "Jira Product Discovery lets product teams capture and prioritize ideas and align everyone with product roadmaps - all in Jira."
                })}
                ctaProps={{
                    buttonProps: {
                        text: getItFreeText,
                        url: signupLink,
                        color: "yellow",
                        dataEventProps: {
                            "data-event": "clicked",
                            "data-event-container": "heroSection",
                            "data-event-component": "linkButton",
                            "data-product-key": "jiraProductDiscovery",
                            "data-label": getItFreeText,
                            "data-label-english": "Get it free",
                            "data-track-event":
                                "jiraProductDiscovery.get-it-free-button-clicked"
                        },
                        onClick: openCrossFlow
                    }
                }}
                isCentered
                cardStyle
            />
        </Row>
    );
};

export default HeroSection;
